import theme from '../../theme';

// Discrete dots on the price scale, colored per-dot by trend: emerald when
// the SAR sits below that bar's close (bullish/support), rose when above
// (bearish/resistance) -- the standard trend-flip convention, more
// informative than a single flat color.
export const drawParabolicSAR = (svg, data, xScale, yScale, values) => {
    if (!values || !Array.isArray(values)) return;

    const points = values
        .map((value, i) => ({
            x: new Date(data[i]?.start_date),
            y: value,
            close: data[i]?.close,
        }))
        .filter((d) => !isNaN(d.y) && d.y !== null && d.close != null);
    if (points.length === 0) return;

    svg.selectAll('.sar-dot')
        .data(points)
        .enter()
        .append('circle')
        .attr('class', 'sar-dot')
        .attr('cx', (d) => xScale(d.x))
        .attr('cy', (d) => yScale(d.y))
        .attr('r', 2)
        .attr('fill', (d) => (d.y < d.close ? theme.indicators.parabolicSar.bullish : theme.indicators.parabolicSar.bearish));
};
